import React from 'react';
import cx from 'classname';
import styles from './successModal.module.scss';

const SuccessModal = ({
  positiveBtn,
  negativeBtn,
  decorationIcon,
  closeIcon,
  title,
  subtitle,
  buttonText,
  secondButtonText,
  buttonStyle,
  showNegativeButton,
  titleStyle,
}) => (
  <div className={cx(styles.backgroundWrapper, styles.display_block)}>
    <div className={styles.container}>
      <div className={styles.container__header}>
        <span
          className={styles.container__negativeBtn}
          onClick={() => negativeBtn()}
        >
          {closeIcon}
        </span>
      </div>

      <div className={styles.container__content}>
        {decorationIcon}

        <p className={cx(titleStyle || '', styles.container__contentTitle)}>
          {title}
        </p>
        <p className={styles.container__contentSubtitle}>{subtitle}</p>

        <div className={styles.buttonWrapper}>
          <button
            onClick={() => positiveBtn()}
            className={cx(buttonStyle || '', styles.container__positiveBtn)}
          >
            {buttonText}
          </button>
          {showNegativeButton && (
            <button
              onClick={() => negativeBtn()}
              className={styles.container__negativeAltBtn}
            >
              {secondButtonText}
            </button>
          )}
        </div>
      </div>
    </div>
  </div>
);

export default SuccessModal;
